// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import $$ResizeObserver from "@react-hook/resize-observer";
function useResizeObserver(ref) {
  var match = React.useState(function () {});
  var setSize = match[1];
  $$ResizeObserver(ref, function (entry) {
    Curry._1(setSize, function (param) {
      return entry.contentRect;
    });
  });
  return match[0];
}
function useWithWindowFallback(ref) {
  var match = ViewportContext$Showside.use(undefined);
  var match$1 = match.windowSize;
  return Belt_Option.getWithDefault(useResizeObserver(Belt_Option.getWithDefault(ref, React.createRef())), {
    width: match$1.width,
    height: match$1.height,
    top: 0
  });
}
export { useResizeObserver, useWithWindowFallback };
/* react Not a pure module */